import Checkbox from '../Checkmark';
import Date from '../Date';
import Input from '../Input';
import InputArea from '../InputArea';
import Select from '../SingleSelect';
import MultiSelect from '../MultiSelect';

import { useTranslation } from 'react-i18next';
import './style.css';
import MultiInput from '../MultipleInput';
import { useEffect } from 'react';

const Forms = ({
  id,
  inputs,
  onInputBlur,
  onInputChange,
  categories,
  departments,
  subDisciplines,
  orgs,
  systems,
  manufacturers,
  costcenters,
  columns = 1, // Default to 1 column
}) => {
  const { t } = useTranslation();

  const concatDynamicOptions = (input) => {
    if (input.main) {
      const mappedKey = input.key;
      switch (mappedKey) {
        case 'category':
          return categories || [];
        case 'department':
          return departments || [];
        case 'subdiscipline':
          return subDisciplines || [];
        case 'organization':
          return orgs || [];
        case 'system':
          return systems || [];
        case 'manufacturer':
          return manufacturers || [];
        case 'cost_center':
          return costcenters || [];
        default:
          return [];
      }
    }
    return [];
  };

  const handleInputType = (input, index) => {
    switch (input?.type) {
      case 'text':
        return (
          <Input
            maxLength={input?.maxLength}
            key={`${id}-input-${index}-${input?.type}-${input.label}`}
            placeholder={typeof input.value === 'function' ? input.value() : input.value}
            type={'text'}
            onBlur={onInputBlur}
            value={typeof input.value === 'function' ? input.value() : input.value}
            disabled={input.disabled}
            onChange={(e) => {
              if (input.onChange) input.onChange(e, index, input);
              else onInputChange(e, index, input);
            }}
          />
        );
      case 'textarea':
        return (
          <InputArea
            maxLength={input?.maxLength}
            key={`${id}-input-${index}-${input?.type}-${input.label}`}
            placeholder={typeof input.value === 'function' ? input.value() : input.value}
            rows={input.rows || 4}
            onBlur={onInputBlur}
            value={typeof input.value === 'function' ? input.value() : input.value}
            disabled={input.disabled}
            onChange={(e) => {
              if (input.onChange) input.onChange(e, index, input);
              else onInputChange(e, index, input);
            }}
          />
        );
      case 'multiText':
        return (
          <MultiInput
            maxLength={input?.maxLength}
            key={`${id}-input-${index}-${input?.type}-${input.label}`}
            placeholder={input.placeholder ?? ''}
            type={'text'}
            onBlur={onInputBlur}
            value={typeof input.value === 'function' ? input.value() : input.value}
            disabled={input.disabled}
            onChange={(e) => {
              if (input.onChange) input.onChange(e, index, input);
              else onInputChange(e, index, input);
            }}
          />
        );
      case 'number':
        return (
          <Input
            maxLength={input?.maxLength}
            key={`${id}-input-${index}-${input?.type}-${input.label}`}
            placeholder={input.value}
            type={'number'}
            value={input.value}
            disabled={input.disabled}
            onChange={(e) => {
              if (input.onChange) input.onChange(e, index, input);
              else onInputChange(e, index, input);
            }}
          />
        );
      case 'multiNumber':
        return (
          <MultiInput
            maxLength={input?.maxLength}
            key={`${id}-input-${index}-${input?.type}-${input.label}`}
            placeholder={input.placeholder ?? ''}
            type={'number'}
            value={input.value}
            disabled={input.disabled}
            onChange={(e) => {
              if (input.onChange) input.onChange(e, index, input);
              else onInputChange(e, index, input);
            }}
          />
        );
      case 'singleSelect':
        return (
          <Select
            key={`${id}-input-${index}-${input?.type}-${input.label}-${JSON.stringify(input.value)}`}
            value={input.value}
            options={[
              ...(Array.isArray(concatDynamicOptions(input)) ? concatDynamicOptions(input) : []),
              ...(Array.isArray(input.options) ? input.options : []),
            ]}
            disabled={input.disabled}
            onChange={(e) => {
              if (input.onChange) input.onChange(e, index, input);
              else onInputChange(e, index, input);
            }}
          />
        );
      case 'multiSelect':
        return (
          <MultiSelect
            key={`${id}-input-${index}-${input?.type}-${input.label}`}
            multi={true}
            value={input.value}
            options={(concatDynamicOptions(input) || []).concat(input.options)}
            disabled={input.disabled}
            onChange={(e) => {
              if (input.onChange) input.onChange(e, index, input);
              else onInputChange(e, index, input);
            }}
          />
        );
      case 'bool':
        return (
          <Checkbox
            key={`${id}-input-${index}-${input?.type}-${input.label}`}
            checked={input.value}
            label=''
            disabled={input.disabled}
            onChange={(e) => {
              if (input.onChange) input.onChange(e, index, input);
              else onInputChange(e, index, input);
            }}
          />
        );
      case 'date':
        return (
          <Date
            key={`${id}-input-${index}-${input?.type}-${input.label}`}
            value={input.value}
            disabled={input.disabled}
            onChange={(e) => {
              if (input.onChange) input.onChange(e, index, input);
              else onInputChange(e, index, input);
            }}
          />
        );
    }
  };

  return (
    <div className='formsBody' style={{ '--grid-columns': columns }}>
      {inputs?.map((input, index) => {
        return (
          <div key={`${input.label}-${index}`} className='formsInputContainer'>
            <div className='formsInputLabel'>{input.label || t(input.key)}:</div>
            <div className='formsInput'>{handleInputType(input, index)}</div>
          </div>
        );
      })}
    </div>
  );
};

export default Forms;
